export const InstanceTemplates = {
  consoleOutputModal: require('core/instance/details/console/consoleOutput.modal.html')
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/instance/templates/index.ts